export default __webpack_public_path__ + "static/media/LogoBL.07a890cd.png";